import { isMobile } from "./mobile";
export async function openAsyncWindow(urlCallback) {
    const openedWindow = window.open("", "_blank");
    if (openedWindow) {
        const fontSize = isMobile() ? "font-size: 30px;" : "";
        openedWindow.document.write(`<html><body><div style="font-family: sans-serif;text-align: center;margin-top: 200px; ${fontSize}">Loading...</div></body></html>`);
    }
    if (!openedWindow)
        return null;
    try {
        const url = await urlCallback();
        if (!url) {
            openedWindow.close();
            return null;
        }
        openedWindow.location.href = url;
    }
    catch (error) {
        openedWindow.close();
        return null;
    }
    return openedWindow;
}
